/**
 * Klassen der nachgebauten antd-Kalenderzelle (CourseDetails, fullscreen=false). Der Präfix kommt
 * aus dem ConfigProvider (`getPrefixCls("picker")`): im iFrame `ant-picker`, im Embed `koe-picker`.
 * Hartkodiert wären die Zellen im Embed-Build ohne Stile (sc-3381).
 */
export function calendarCellClassNames(pickerPrefix: string, isToday: boolean): { inner: string; value: string; content: string } {
    const calendarDate = `${pickerPrefix}-calendar-date`
    return {
        inner: `${pickerPrefix}-cell-inner ${calendarDate}${isToday ? ` ${calendarDate}-today` : ""}`,
        value: `${calendarDate}-value`,
        content: `${calendarDate}-content`,
    }
}
